
<ss-activity-item-unordered 
    *ngFor="let activity of activitiesSubject | async;trackBy: trackActivityById;let idx = index" 
    [activity]="activity" 
    [activityId]="activity.id"
    class="border-gray"
    
></ss-activity-item-unordered>
